import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations, contactInfo, renderImages } from '../data/mock';
import { Mail, Phone, MessageCircle } from 'lucide-react';

const ContactSection = ({ onOpenContactForm }) => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <section id="contact" className="relative py-24 lg:py-32 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src={renderImages[1].url}
          alt="Background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-stone-900/80" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        <h2 className="font-serif text-4xl md:text-5xl text-white mb-4">
          {t.contact.title}
        </h2>
        <p className="text-white/80 text-lg mb-12">
          {t.contact.subtitle}
        </p>

        {/* Contact Options */}
        <div className="grid md:grid-cols-3 gap-6 mb-12">
          {/* Phone */}
          <a
            href={`tel:${contactInfo.phone}`}
            className="bg-white/10 backdrop-blur-sm p-8 hover:bg-white/20 transition-colors group"
          >
            <Phone className="mx-auto mb-4 text-white/80 group-hover:text-white transition-colors" size={28} strokeWidth={1.5} />
            <div className="text-white/60 text-sm uppercase tracking-wider mb-2">
              {t.contact.phone}
            </div>
            <div className="text-white font-light">
              {contactInfo.phone}
            </div>
          </a>

          {/* Email */}
          <a
            href={`mailto:${contactInfo.email}`}
            className="bg-white/10 backdrop-blur-sm p-8 hover:bg-white/20 transition-colors group"
          >
            <Mail className="mx-auto mb-4 text-white/80 group-hover:text-white transition-colors" size={28} strokeWidth={1.5} />
            <div className="text-white/60 text-sm uppercase tracking-wider mb-2">
              {t.contact.email}
            </div>
            <div className="text-white font-light">
              {contactInfo.email}
            </div>
          </a>

          {/* WhatsApp */}
          <a
            href={`https://wa.me/${contactInfo.whatsapp}`}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-white/10 backdrop-blur-sm p-8 hover:bg-white/20 transition-colors group"
          >
            <MessageCircle className="mx-auto mb-4 text-white/80 group-hover:text-white transition-colors" size={28} strokeWidth={1.5} />
            <div className="text-white/60 text-sm uppercase tracking-wider mb-2">
              WhatsApp
            </div>
            <div className="text-white font-light">
              {contactInfo.phone}
            </div>
          </a>
        </div>

        {/* CTA Button */}
        <button
          onClick={onOpenContactForm}
          className="inline-block px-10 py-4 bg-white text-stone-800 text-sm tracking-widest uppercase hover:bg-stone-100 transition-colors"
        >
          {t.contact.cta}
        </button>
      </div>
    </section>
  );
};

export default ContactSection;
